import amapi from '@/api/amapi'

const initialState = () => ({})

const state = initialState

const getters = {}

const mutations = {}

const actions = {
  // load subdomains list
  async sitebuilderLogin ({ commit, dispatch }, serviceId) {
    let w = window.open()
    w.document.write('Connecting...')
    try {
      const response = await amapi.makecall('sitebuilder_login', { id: serviceId })
      if (response.result === 'success') {
        w.location = response.url
      } else {
        w.close()
        dispatch('reportError', 'Unable to login to site builder', { root: true })
      }
    } catch (e) {
      w.close()
      dispatch('reportError', 'Unable to login to site builder', { root: true })
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
